import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Fetches the current Cognito ID token string from the Amplify session.
 * Used as the Bearer token in API requests.
 */
export async function generateJwt(): Promise<string> {
  const session = await fetchAuthSession();
  return session?.tokens?.idToken?.toString() ?? '';
}
